import React from "react";
import FormCard from "../FormComponents/FormCard";
import SectionTitle from "../FormComponents/SectionTitle";
import AlertBanner from "../FormComponents/AlertBanner";
import Icon from "../Icons/Icon";

/**
 * Step 2: Show Contacts & Important Information
 *
 * This step displays contact information and show guidelines.
 */
const Step2 = () => (
  <div className="form-page">
    <div className="form-page-header">
      <h2 className="form-page-title">Show Contacts & Important Information</h2>
    </div>

    <FormCard title="Show Contacts" icon={<Icon name="phone" size={14} />}>
      <SectionTitle>Program Questions</SectionTitle>
      <p
        style={{ fontSize: 13, color: "var(--neutral-600)", marginBottom: 12 }}
      >
        Arett Merchant and Merchant Planner
      </p>
      <table className="contract-table" style={{ marginBottom: 20 }}>
        <thead>
          <tr>
            <th>Merchant</th>
            <th>Phone Ext</th>
            <th>Merchant Planner</th>
            <th>Ext #</th>
          </tr>
        </thead>
        <tbody>
          {[
            {
              m: "pcolon@arett.com",
              e: "269",
              mp: "hsherif@arett.com",
              me: "298",
            },
            {
              m: "kcolletti@arett.com",
              e: "224",
              mp: "",
              me: "",
            },
            {
              m: "smarut@arett.com",
              e: "256",
              mp: "rconway@arett.com / bhealey@arett.com",
              me: "284 / 233",
            },
            {
              m: "arussick@arett.com",
              e: "249",
              mp: "egoletz@arett.com",
              me: "276",
            },
          ].map((r, i) => (
            <tr key={i}>
              <td>
                <a className="link" href={`mailto:${r.m}`}>
                  {r.m}
                </a>
              </td>
              <td>{r.e}</td>
              <td>
                <a className="link" href={`mailto:${r.mp}`}>
                  {r.mp}
                </a>
              </td>
              <td>{r.me}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="contact-block">
        <div className="contact-block-title">Show Payments to Arett</div>
        <div
          style={{ fontSize: 14, color: "var(--neutral-700)", lineHeight: 1.8 }}
        >
          Arett Sales —{" "}
          <strong style={{ color: "var(--primary)" }}>
            Attn: Bethann Miller
          </strong>
          <br />
          9285 Commerce Highway, Pennsauken, NJ 08110
          <br />
          Email:{" "}
          <a className="link" href="mailto:bmiller@arett.com">
            bmiller@arett.com
          </a>
          <br />
          <span style={{ color: "var(--danger)", fontWeight: 600 }}>
            800-257-8220 ext#217
          </span>
          <br />
          Payment Terms: 07/01/2026 or Net 10 days after signed agreement.
        </div>
      </div>

      <table className="contract-table" style={{ marginBottom: 16 }}>
        <tbody>
          <tr>
            <td className="text-bold" style={{ width: 220 }}>
              Show Logistics: Freight / Setup / Breakdown
            </td>
            <td>
              Bernie Campbell and Ed Torio
              <br />
              <a className="link" href="mailto:bcampbell@arett.com">
                bcampbell@arett.com
              </a>{" "}
              (ext #271) &nbsp;&nbsp;
              <a className="link" href="mailto:etorio@arett.com">
                etorio@arett.com
              </a>{" "}
              (ext #204)
            </td>
          </tr>
          <tr>
            <td className="text-bold">Floor Plan/Booth</td>
            <td>Arett Merchant</td>
          </tr>
          <tr>
            <td className="text-bold" style={{ color: "var(--primary)" }}>
              General Exposition Services
            </td>
            <td>
              <a
                className="link"
                href="https://www.generalexposition.com/online-servicekit.php"
                target="_blank"
                rel="noreferrer"
              >
                https://www.generalexposition.com/online-servicekit.php
              </a>
              <br />
              <span className="text-small">
                Click above to order: Furniture, Advanced Warehouse Freight, Air
                Ground & Van Line Freight
              </span>
              <br />
              Questions? Email:{" "}
              <a className="link" href="mailto:info@generalexposition.com">
                info@generalexposition.com
              </a>{" "}
              | Call: 610-495-8866
            </td>
          </tr>
          <tr>
            <td className="text-bold" style={{ color: "var(--primary)" }}>
              AC Convention Services
            </td>
            <td>
              <a
                className="link"
                href="https://meetac.boomerecommerce.com/"
                target="_blank"
                rel="noreferrer"
              >
                https://meetac.boomerecommerce.com/
              </a>
              <br />
              <span className="text-small">
                Click above to order: A/V Equipment, Electric & Water
              </span>
              <br />
              Questions? Email:{" "}
              <a className="link" href="mailto:Brittany.Cox@oakviewgroup.com">
                Brittany.Cox@oakviewgroup.com
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </FormCard>

    <FormCard
      title="Important Show Information"
      icon={<Icon name="alert" size={14} />}
    >
      <AlertBanner type="info">
        ** IMPORTANT: All exhibitors must check in at the registration desk no later than NOON on Day 2 of setup to avoid a $500 late fee.
      </AlertBanner>

      {[
        {
          title: "Cleaning",
          text: "All booths must be completely cleared of debris and kept clean at all times. Any extraordinary cleaning will incur additional charge of $250 per day.",
        },
        {
          title: "Product Display",
          text: "All booths should be fully stocked and well merchandised with product listed on your program only! The Arett Sales' Merchant staff must approve all products displayed in booth. No exceptions!",
        },
        {
          title: "Advanced Inbound Freight",
          text: 'Will be delivered to your booth on Monday, 09/14/2026, if received by Monday, 08/31/2026. Advance freight is the preferred method of fast and accurate product delivery.\n\n1. ALL freight should be marked with your Arett Vendor Id # and Arett Sales Show to insure accurate delivery.\n2. Receiving hours are 9:00 am – 3:00 pm Monday - Friday\n3. Ship all Advanced Freight to and mark it accordingly:\n\nGeneral Exposition Services/ARETT SALES OPEN HOUSE\nCompany Name/ your Arett Booth# / Mfr ID\nc/o Warehouse Manager – Box X of X\n205 Windsor Road, Pottstown, PA 19464\n\n4. Materials should be shipped to ARRIVE at General Exposition Services warehouse NO LATER THAN Monday, 08/31/2026.\n5. Unloading freight – "Empty" stickers are provided during move-in to affix to boxes.',
        },
        {
          title: "Hand-Carried Freight",
          text: "Hand-carried freight must enter through the garage area to access the elevator and must be small enough to be transported using only a personal luggage carrier. Larger freight must be brought into the show through the freight gates and handled by General Exposition Services.",
        },
        {
          title: "Selling Your Booth (at the close of the show)",
          text: "You must provide Arett Sales with Advance Notice if you are selling your booth. No booth can leave the show prior to breakdown on Thursday, September 17th, the closing day of the Show.",
        },
        {
          title: "Show Breakdown and Outbound Freight",
          text: "It is the responsibility of the Exhibitor to arrange shipping of their booth. Carriers must check-in on Thursday, September 17th, 2026 between 7:00 pm and 10:00 pm, otherwise, it will be shipped by General Exposition Services, freight collect.",
        },
      ].map((item, i) => (
        <div key={i} style={{ marginBottom: 18 }}>
          <div
            style={{
              fontWeight: 700,
              fontSize: 14,
              color: "var(--neutral-800)",
              marginBottom: 6,
            }}
          >
            {item.title}
          </div>
          <p
            style={{
              fontSize: 13,
              color: "var(--neutral-600)",
              lineHeight: 1.7,
              whiteSpace: "pre-line",
            }}
          >
            {item.text}
          </p>
        </div>
      ))}
    </FormCard>

    <div className="form-footer-note">
      <strong>PLEASE PRINT THIS OUT FOR YOUR RECORDS</strong>
      <br />
      Please refer to vendor portal for any and all updates. Email updates will
      also be sent so be sure to whitelist all @arett.com domains
    </div>
  </div>
);

export default Step2;
